import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/chip/chip.tsx
import React from "react";
var Chip = ({ onClick, name, isSelected }) => /* @__PURE__ */ React.createElement(
  "button",
  {
    onClick,
    type: "button",
    className: cn(
      "inline-flex h-10 min-h-9 cursor-pointer items-center justify-center rounded-md border border-action-outline px-4 py-2 align-bottom text-action-outline-foreground transition-button duration-300 ease-out my-label-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus disabled:cursor-not-allowed disabled:opacity-50",
      {
        "border-[theme(backgroundColor.interactive-accent-surface-active)] bg-action-tonal-surface text-interactive-accent-foreground-active hover:border-[theme(backgroundColor.interactive-accent-surface-active)]": isSelected
      }
    )
  },
  name
);

export {
  Chip
};
